import { useEffect } from 'react';

export function useBeforeUnload(onBeforeUnload: (e: BeforeUnloadEvent) => void, deps: unknown[] = []) {
    useEffect(() => {
        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, deps);
}
